import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="logo-wrapper">
          <Link to="/">
            <h3>Swift Tech Pay</h3>
          </Link>
        </div>
        <ul className="footer-items">
          <li>Careers</li>
          <li>Terms of Service</li>
          <li>Privacy Policy</li>
          <li>Facebook</li>
          <li>Linkedin</li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;
